export const baseUrl =  `https://dev-api.clinicsoncloud.co/api/v3/`


export const Url = {
LOGIN_KIOSK:`${baseUrl}login/kiosk`,
CHECK_UPDATE:`${baseUrl}apk/check-update`,
}